/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import KImage from '@/types/KImage'
import Video from './Video'

export default class HeroWithVideo {
  private json: any
  public readonly uid: string
  public readonly description: string
  public readonly getStartedButtonText: string
  public readonly headingOne: string
  public readonly headingTwo: string
  public readonly video: Video
  public readonly alternativeImage?: KImage

  constructor (json: any, alternativeImage?: KImage) {
    this.json = json
    this.uid = json.uid
    this.description = json.description
    this.getStartedButtonText = json.get_started_button_text
    this.headingOne = json.heading_one
    this.headingTwo = json.heading_two
    this.video = json.video ? Video.of(json.video) : Video.empty()
    if (alternativeImage) {
      this.alternativeImage = alternativeImage
    }
  }

  static of (json: any, alternativeImage?: KImage): HeroWithVideo {
    return new HeroWithVideo(json, alternativeImage)
  }

  static empty (): HeroWithVideo {
    return new HeroWithVideo({
      uid: '',
      description: '',
      get_started_button_text: '',
      heading_one: '',
      heading_two: '',
      video: undefined
    })
  }
}
